import React from 'react';
import { connect } from 'react-redux';
import intl from 'react-intl-universal';
import withSnackbar from 'src/utils/Notifications/withSnackbar';
import UploadView from './UploadViewContainer';
import { getFileTypes } from 'src/helpers/upload';
import DOMPurify from 'dompurify';
import UploadPad from 'src/ui/library/ContentParser/controls/FileUploadControl/UploadPad.js';
import { ATTACHMENT_TYPES } from 'src/constants/constants';
import { addCMSFileIgnoreInterceptor, removeCMSFile, downloadCMSFile } from 'src/services/cms.service';
import download from 'downloadjs';
import mime from 'mime-types';
import InfoTooltip from 'src/ui/library/ContentParser/controls/Tooltip/InfoTooltip';
import ServiceSpinner from 'src/ui/library/ServiceSpinner';

const getAnswerId = attachment => (typeof attachment.answerId === 'number' ? attachment.answerId : attachment.id);

class FileUploadControl extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      attachments: this.getInitialAttachments(),
      selectedAttachments: [],
      arrayFileTypes: null,
      errorTextUpload: null,
      showSpinner: false,
      deviceOS: null,
      selectedCmpCamera: null,
    };
  }

  componentDidMount() {
    const arrayFileTypes = sessionStorage.getItem('supportedfileTypes');
    this.setState({ arrayFileTypes: arrayFileTypes });
  }

  getInitialAttachments = () => {
    const { uploadedDocuments } = this.props;

    if (!uploadedDocuments) return [];

    //this is only used when the control is being populated with metadata instead of actual Files
    const attachments = uploadedDocuments.map(({ answerId, documentName, fileLength, createdDate, uploadedBy }) => {
      //if we call on change at every initial render it will give "Save" pop-up whenever document name is available
      //this.props.onChange({ target: { value: documentName } });
      return {
        answerId,
        fileName: documentName,
        fileSize: fileLength,
        createdDate,
        uploadedBy,
      };
    });

    return attachments;
  };

  handleOnChange = () => {
    const { onChange } = this.props;
    const { attachments } = this.state;

    // const attachmentData = attachments.map(item => ({
    //   id: item.id,
    //   fileName: item.fileName
    // }));

    if (attachments.length && attachments[0].fileName) onChange({ target: { value: attachments[0].fileName } });
  };

  handleFormatFiles = arrayFileTypes => {
    return arrayFileTypes ? arrayFileTypes : getFileTypes(ATTACHMENT_TYPES).join();
  };

  handleOnDrop = fileData => {
    this.sendFile(fileData);
  };
  /**
   *
   * @param {string} variant added | error | deleted ! errorAdding
   */
  enqueueSnackbar = (variant, response = null) => {
    let message = `questionnaire.documents.${variant}`;
    if (variant === 'errorAdding') {
      this.settimeError = setTimeout(() => {
        this.setState({ errorTextUpload: null });
      }, 15000);
      if (response && typeof response !== 'string') {
        if (response && response.data && response.data.error && response.data.error.code && response.data.error.code === 404) {
          const errorTextUpload = intl.get(message) + '<br/>' + response.data.error.message;
          this.setState({ errorTextUpload });
        } else {
          const errorTextUpload = intl.get(message) + '<br/>' + this.state.arrayFileTypes;
          this.setState({ errorTextUpload });
        }
      }
    }
    if (variant === 'errorInvalidFile') {
      variant = 'error';
      message = `questionnaire.documents.errorAdding`;
      const arrayFileTypes = sessionStorage.getItem('supportedfileTypes');
      const fileSupport = arrayFileTypes ? arrayFileTypes.split(',') : [];

      this.settimeError = setTimeout(() => {
        this.setState({ errorTextUpload: null });
      }, 15000);
      const errorTextUpload = intl.get(message) + '<br/>' + intl.get('questionnaire.documents.errorInvalidFile') + fileSupport.join(', ');
      this.setState({ errorTextUpload });
    } else if (variant === 'errorAdding' || variant === 'error') {
      variant = 'error';
    } else {
      variant = 'success';
    }
    this.props.enqueueSnackbar(intl.get(message), {
      variant,
    });
  };

  sendFile = (fileData, keyComponet) => {
    const { id, pageId } = this.props;

    if (!fileData.length) {
      //this.enqueueSnackbar('error');
      this.enqueueSnackbar('errorInvalidFile');
    }
    const fnIterator = async (data, indexItem, iteratorIndex) => {
      let attachment;
      const response = await addCMSFileIgnoreInterceptor(data, {
        onUploadProgress: progressEvent => {
          const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          const { attachments } = this.state;
          attachments[indexItem].progress = percentCompleted;
          this.setState({ attachments });
        },
      });
      if (response && response.messages) {
        attachment = {
          progress: 0,
          id: response.messages.answerId,
          fileName: response.messages.documentName,
          fileSize: response.messages.fileLength,
          createdDate: response.messages.createdDate,
          uploadedBy: response.messages.uploadedBy,
        };
        const { attachments } = this.state;
        attachments[indexItem] = attachment;
        this.setState({ attachments });
        this.enqueueSnackbar('added');
      } else {
        this.enqueueSnackbar('errorAdding', response);
      }

      return Promise.resolve({ iteratorIndex });
    };

    const { attachments } = this.state;
    const fileDataLength = fileData.length;
    let counter = 0;

    fileData.reduce(async (acc, dataItem, iteratorIndex) => {
      const data = new FormData();
      data.append('attachmentData', dataItem);
      data.append('elementName', id);
      data.append('pageId', pageId);
      attachments.push({
        progress: 10,
        file: dataItem,
      });
      const indexItem = attachments.length - 1;
      this.setState({ attachments, showSpinner: true });
      await acc.then(() => fnIterator(data, indexItem, iteratorIndex));
      counter++;
      if (fileDataLength === counter) {
        const { attachments } = this.state;
        const _filterAttachmnents = attachments.filter(file => file && !file.progress);
        this.setState(
          prevState => ({
            attachments: _filterAttachmnents,
            showSpinner: false,
          }),
          () => {
            this.handleOnChange();
          },
        );
      }
    }, Promise.resolve());
  };

  deleteFile = index => {
    const { attachments } = this.state;
    const AnswerId = getAnswerId(attachments[index]);
    removeCMSFile({ AnswerId }).then(res => {
      if (res && res.success) {
        this.setState(
          prevState => ({
            attachments: prevState.attachments.filter(a => getAnswerId(a) !== AnswerId),
            selectedAttachments: [],
          }),
          () => {
            this.handleOnChange();
          },
        );
        this.enqueueSnackbar('deleted');
      } else {
        this.enqueueSnackbar('error');
      }
    });
  };

  downloadFile = index => {
    const { attachments } = this.state;
    this.setState({ showSpinner: true });
    const AnswerId = getAnswerId(attachments[index]);
    downloadCMSFile({ AnswerId }).then(response => {
      if (response && response.success && response.attachmentData) {
        let data = response.attachmentData;
        let fileName = response.fileName;
        download(atob(data), fileName, mime.lookup(fileName));
      }
      this.setState({ showSpinner: false });
    });
  };

  onSelected = val => {
    this.setState(prevState => {
      const indexOfSelected = prevState.selectedAttachments.indexOf(val);
      return {
        selectedAttachments:
          indexOfSelected > -1
            ? prevState.selectedAttachments.filter((v, i) => i !== indexOfSelected)
            : [...prevState.selectedAttachments, val],
      };
    });
  };

  deleteSelected = val => {
    const { selectedAttachments, attachments } = this.state;
    const allPromises = [];
    selectedAttachments.forEach((val, index) => {
      const attachment = attachments[val];
      const AnswerId = getAnswerId(attachment);
      allPromises.push(
        removeCMSFile({ AnswerId }).then(res => {
          if (res && res.success) {
            this.setState(prevState => ({
              attachments: prevState.attachments.filter(a => getAnswerId(a) !== AnswerId),
            }));
            return Promise.resolve();
          }
          return Promise.reject();
        }),
      );
    });
    Promise.all(allPromises).then(() =>
      this.setState({ selectedAttachments: [] }, () => {
        this.enqueueSnackbar('deleted');
      }),
    );
  };

  render() {
    const { attachments, selectedAttachments, errorTextUpload, showSpinner, arrayFileTypes } = this.state;
    const { label, required, helpText, hasError } = this.props;
    console.warn('enabled', !!selectedAttachments.length);
    const errorText = hasError ? intl.get('questionnaire.showModal.alertMessageForFile') : null;
    return (
      <React.Fragment>
        {showSpinner && <ServiceSpinner downlaodSpinner={showSpinner} open={true} />}
        <div className="file-upload-wrapper">
          <span className="upload-label">{label}</span>
          {required && <span>{intl.get('questionnaire.requiredLabel')}</span>}
          {helpText && <span>&nbsp;</span>}
          {helpText && <InfoTooltip toolTipText={helpText} />}
          {errorTextUpload && (
            <div>
              <p
                className="file-upload-error-text"
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(errorTextUpload),
                }}
              />
            </div>
          )}
          <div className="upload-control-wrapper">
            <UploadPad dropHandler={this.handleOnDrop} acceptedFileTypes={this.handleFormatFiles(arrayFileTypes)} closeHandler={null} />
          </div>
          <UploadView
            attachments={attachments}
            selectable={true}
            selectAction={'Delete'}
            menu={[
              {
                icon: 'Delete',
                text: intl.get('controls.delete'),
                handler: this.deleteFile,
              },
              {
                icon: 'CloudDownload',
                text: intl.get('controls.download'),
                handler: this.downloadFile,
              },
            ]}
            onSelected={this.onSelected}
            showBorder={true}
            deleteSelected={this.deleteSelected}
            deleteEnabled={!!selectedAttachments.length}
            selectedAttachments={selectedAttachments}
          />
          {hasError && (
            <p
              className="file-upload-error-text"
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(errorText),
              }}
            />
          )}

          {!attachments.length && <p className="control-file-info-header">{intl.get('documents.notUploaded')}</p>}
        </div>
      </React.Fragment>
    );
  }
}
const mapStateToProps = state => {
  return {
    isMobile: state.browser.is.small || state.browser.is.extraSmall,
    browser: state.browser,
  };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(withSnackbar(FileUploadControl));
